import { useInfiniteQuery } from "@tanstack/react-query";
import { ApiGetFortAgentAifVestingPayoutRecords } from "@/api";
import type { GetFortAgentAifVestingPayoutRecordsResponse } from "@/api/types";
import { useUserStore } from "@/store/useUserStore";
import { FORT_AGENT_PAYOUT_PAGE_SIZE } from "./useGetFortAgentStaticPayoutRecords";

export function useGetFortAgentAifVestingPayoutRecords(
  agentId: number,
  enabled: boolean
) {
  const { userInfo } = useUserStore();
  return useInfiniteQuery({
    queryKey: ["fortAgentAifVestingPayoutRecords", agentId],
    queryFn: async ({
      pageParam,
    }): Promise<GetFortAgentAifVestingPayoutRecordsResponse> => {
      const res = await ApiGetFortAgentAifVestingPayoutRecords({
        page: pageParam,
        pageSize: FORT_AGENT_PAYOUT_PAGE_SIZE,
        agentId,
      });
      console.log("useGetFortAgentAifVestingPayoutRecords", res.data);
      return res.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const fetched = allPages.reduce(
        (sum, page) => sum + (page.records?.length ?? 0),
        0
      );
      if (fetched >= (lastPage.total ?? 0)) return undefined;
      return allPages.length + 1;
    },
    enabled: enabled && !!userInfo?.address,
  });
}
